import { preffixTestIds } from 'utility/e2e'

export const DigitalTwinTestIds = preffixTestIds('digital-twin')({
  FILE_UPLOAD: 'file-upload',
  PREVIEW: 'preview',
  REMOVE_FILE: 'remove',
  PRICE: 'price',
  PIX: 'pix',
  ADDRESS_OPTION: 'add',
  DESCRIPTION: 'description',
  CONTAINER: 'container',
  ERROR_INDICATOR: 'error-ind'
})
